export const VIRTUAL_SECTION_ID = 'virtualId';
export const ROOT_CASES_SECTION_NAME = 'Without Section';
